ui-cms-socials {
  display: block;
  width: 100%;

  .sr-only {
    @include sr-only;
  }

  sd-icon {
    font-size: $sd-fontSize-3xl;
  }

  .social-links-wrapper {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    gap: 0.5rem;

    &.align-right {
      justify-content: flex-end;
    }

    // show whatsapp only on mobile/tablet
    @include breakpoint($desktop) {
      .social-btn--whatsapp {
        display: none;
      }
    }
  }
}
